import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const MAX_SET_SCROLL_ATTEMPTS = 10;

export const usePreserveScroll = () => {
  const router = useRouter();

  const scrollPositions = useRef<{ [url: string]: number }>({});
  const isBack = useRef(false);

  useEffect(() => {
    router.beforePopState(() => {
      isBack.current = true;
      return true;
    });

    const onRouteChangeStart = () => {
      const url = router.asPath;

      scrollPositions.current[url] = window.scrollY;
    };

    const onRouteChangeComplete = (url: any) => {
      if (isBack.current && url && scrollPositions.current[url]) {
        // Замыкаем переменную
        const scrollPosition = scrollPositions.current[url];
        // Каунтер для подсчета кол-ва пройденных итераций
        let counter = 0;

        // Пытаемся обновить
        const updateScrollPositionInterval = setInterval(() => {
          if (
            counter >= MAX_SET_SCROLL_ATTEMPTS ||
            window.scrollY === scrollPosition
          ) {
            clearInterval(updateScrollPositionInterval);
          } else {
            window.scroll({
              top: scrollPosition,
              behavior: 'auto',
            });

            counter++;
          }
        }, 100);
      }

      isBack.current = false;
    };

    router.events.on('routeChangeStart', onRouteChangeStart);
    router.events.on('routeChangeComplete', onRouteChangeComplete);

    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart);
      router.events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, [router]);
};
